export const APP_ID = 'carbon';
export const APP_VERSION = 'v1.4';
export const NETWORK = import.meta.env.VITE_NETWORK || 'ethereum';
